module.exports = __webpack_public_path__ + "static/mw1-421974640340d189d5fdefb579a7246a.jpg";